module.exports = __webpack_public_path__ + "img/icone-sair.b1e699d8.svg";